<template>
  <div>
    <!-- <header class="header">
      <h1>统计报告</h1>
    </header> -->
    <van-nav-bar class="vannavbar" title="统计报告" left-text="" right-text="" left-arrow @click-left="onClickLeft"/>
    <div class="mark"></div>
		<div class="toast"></div>
		<div class="content">
      <div class="tabnav">
        <div class="tabnav-tody" @click="showPicker">{{tabtody}}</div>
        <div class="tabnav-sort" @click="range">{{tabsort}}</div>
      </div>
      <!-- 销售业绩 -->
      <div id="part1">

        <div class="sceenBox">
          <h2>{{tabtody}}统计</h2>
          <span>查看范围</span>
          <ul class="userBox clear">
            <li v-for="item in getChildData" :class="count == item.id ? 'userLiActive':''" :key="item.id" @click="userData(item)">{{item.name}}</li>
          </ul>
        </div>

        <h3 class="small-title">销售业绩</h3>

        <div class="mui-row">
          <div class="part1-col">
            <div><i>￥</i>{{detail.planSalesAmount}}<i>万</i></div>
            <span>计划销售金额</span>
          </div>
          <div class="part1-col">
            <div><i>￥</i>{{detail.realSalesAmount}}<i>万</i></div>
            <span>实际销售金额</span>
          </div>
          <div class="part1-col">
            <div>{{detail.salesCompletionRate}}</div>
            <span>销售完成率</span>
          </div>
        </div>

        <div class="mui-row">
          <div class="mui-col-xs-4 part1-col">
            <div><i>￥</i>{{detail.planBackAmount}}<i>万</i></div>
            <span>计划回款</span>
          </div>
          <div class="mui-col-xs-4 part1-col">
            <div><i>￥</i>{{detail.realBackAmount}}<i>万</i></div>
            <span>实际回款</span>
          </div>
          <div class="mui-col-xs-4 part1-col">
            <div>{{detail.backAmountCompletionRate}}</div>
            <span>回款完成率</span>
          </div>
        </div>

        <!--柱状图-->
        <div class="chart" id="barChart"></div>

        <div class="mui-row">
          <div class="part1-sum">
            <div>本期销售额 <span>¥{{detail.currSalesAmount}}万</span></div>
          </div>
          <div class="part1-sum">
            <div>同期销售额 <span>¥{{detail.sameTermSalesAmount}}万</span></div>
          </div>
          <div class="part1-sum">
            <div>同比增长率 <span>{{detail.sameTermRate}}</span></div>
          </div>
        </div>

      </div>

      <!--销售执行力 -->
      <div id="part2">
        <h3 class="small-title">销售执行力</h3>
        <div class="mui-row">
          <div class="part1-col">
            <div>{{detail.totalCustomerCount}}</div>
            <span>所有客户</span>
          </div>
          <div class="part1-col">
            <div>{{detail.totalFollowCount}}</div>
            <span>总跟进数</span>
          </div>
          <div class="part1-col">
            <div>{{detail.visitCount}}</div>
            <span>拜访签到数</span>
          </div>
        </div>
        <div class="mui-row">
          <div class="part1-col">
            <div>{{detail.newClueCount}}</div>
            <span>新增线索</span>
          </div>
          <div class="part1-col">
            <div>{{detail.newContractCount}}</div>
            <span>新增合同数</span>
          </div>
          <div class="part1-col">
            <div>{{detail.convertCustomerCount}}</div>
            <span>转化签约客户数</span>
          </div>
        </div>
      </div>
      
      <!--线索转化率-->
      <div id="part3">
        <h3 class="small-title">线索转化率</h3>
        <div class="pull">
          <div class="pull-left part3-num">
            <!--<div>
              <span>线索总数</span>{{detail.newClueCount}}
            </div>-->
            <div>
              <span>新增线索</span>{{detail.newClueCount}}
            </div>
            <div>
              <span>已转换线索</span>{{detail.convertCustomerCount}}
            </div>
          </div>
          <div class="pull-right">
            <van-circle v-model="currentRate" :rate="rate" :speed="100" layer-color="#bed8fa" :text="text" />
          </div>
        </div>
      </div>
		</div> 
  </div>
</template>

<script>
import echarts from 'echarts'
import { mapGetters } from 'vuex'
import { countReport } from '@/api/resetApi.js'
export default {
  name: 'index',
  data() {
    return {
      count: 0,
      rate: 0,
      currentRate: 0,
      tabtody: '本周',
      tabsort: '查看范围',
      tabIndex: [1],
      column1: [{ text: '昨天', value: '1'}, { text: '本周', value: '2' },{ text: '上周', value: '3' },{ text: '本月', value: '4' },{ text: '上月', value: '5' },{ text: '本季度', value: '6' },{ text: '上季度', value: '7' },{ text: '本年', value: '8' },{ text: '去年', value: '9' }],
      nameList:[],
      info:{
        countTimeType:'2',
        userIds:[]
      },
      detail:{
        planSalesAmount:'',
        realSalesAmount:'',
        salesCompletionRate:'',
        planBackAmount:'',
        realBackAmount:'',
        backAmountCompletionRate:'',
        currSalesAmount:'',
        currTimestamp:'',
        sameTermSalesAmount:'',
        sameTermTimestamp:'',
        sameTermRate:'',
        totalFollowCount:'',
        visitCount:'',
        newClueCount:'',
        convertCustomerCount:'',
        newContractCount:'',
        totalCustomerCount:'',
        convertRate: 0,
      },
    }
  },
  created(){
    if (this.$route.query.ukey) {
      if (!localStorage.getItem('ukey') || localStorage.getItem('ukey') !== this.$route.query.ukey || localStorage.getItem('utoken') !== this.$route.query.utoken) {
        localStorage.setItem('ukey', this.$route.query.ukey)
        localStorage.setItem('utoken', this.$route.query.utoken)
      }
    }
    if(this.$route.query.type != undefined && this.$route.query.typeText != undefined){
      this.info.countTimeType = this.$route.query.type
      this.tabtody = this.$route.query.typeText
    }
    this.getData(this.info.countTimeType,null)
  },
  computed: {
    ...mapGetters([
      'getChildData',
      'checkList'
    ]),
    text() {
      return this.currentRate.toFixed(0) + '%';
    },
  },
  methods: {
    onClickLeft() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
      if(isAndroid){
        SAPP.back();
      }else{
        window.webkit.messageHandlers.back.postMessage({});
      }
    },
    range() {
      this.$router.push({
        path:'/SalesRange',
        query:{
          type:this.info.countTimeType,
          typeText:this.tabtody
        }
      })
    },
    userData(row) {
      this.getData(this.info.countTimeType,row.id);
      this.count = row.id
    },
    // 打开选择快速查询
    showPicker() {
      this.$createPicker({
        title: '快速查询',
        data: [this.column1],
        selectedIndex: this.tabIndex,
        onSelect: this.selectHandle,
        onCancel: this.cancelHandle
      }).show()
    },
    // 选择快速查询
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.info.countTimeType = selectedVal.toString();
      this.tabtody = selectedText.toString();
      if (this.count == 0) {
        this.getData(this.info.countTimeType,this.checkList);
      } else {
        this.getData(this.info.countTimeType,this.count);
      }
      console.log('selectedVal',selectedVal)
      console.log('selectedIndex',selectedIndex)
      console.log('selectedText',selectedText)
    },
    // 获取所有数据
    async getData(type,ids){
      console.log('type',type)
      let idList = []
      if(ids == null){
        idList = this.checkList
      } else if (Array.isArray(ids)) {
        idList = ids
      } else {
        idList.push(ids)
      }
      let data = {
        countTimeType:parseInt(type),
		    userIds:idList
      }
      const res = await countReport(data)
      console.log('countReport=',res)
      try {
        if (res.data.code === 200) {
          this.detail = res.data.data
          this.convertRate = res.data.data.convertRate
          this.barConfig(this.detail)
          this.rate = this.convertRate
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 柱状图配置
    barConfig(data){
      console.log(data)
      var options = {
        legend: { data: []},
        grid: {x: 28,x2: 45,y: 30,y2: 23},
        toolbox: {
          show: false,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: false
            },
            magicType: {
              show: true,
              type: ['line', 'bar']
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: false,
        xAxis: [{
      		// axisLabel: {
          //   interval:0,
          //   rotate:40
          // },
          name:'日期',
          type: 'category',
          data: [data.sameTermTimestamp,data.currTimestamp]
          // data: ['2020-04-22','2020-04-27']
        }],
        yAxis: [{
          type: 'value',
          name:'万元',
          splitArea: {
            show: true
          },
        }],
        series: [{
          name: '同期',
          type: 'bar',
          barWidth:50,
          data: [data.sameTermSalesAmount.toString(),data.currSalesAmount.toString()]
          // data: [0,10]
        }]
      }
      var barChart = echarts.init(document.getElementById('barChart'));
      barChart.setOption(options);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.clear:after {
  clear: both;
  overflow: hidden;
  font-size: 0;
  height: 0;
  visibility: hidden;
  display: block;
  content: ".";
}
.vannavbar {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
}
.content{
	background:#F7F7F7;
	margin-top: 44px;
}
.tabnav {
	display: flex;
  font-size: 14px;
  color: #181818;
  background: #fff;
  padding: 14px 0;
  margin-bottom: 12px;
  .tabnav-tody {
    flex: 1;
    border-right: 1px solid #ccc;;
  }
  .tabnav-sort {
    flex: 1;
    color: #181818;
  }
}


.mark{
	position: fixed;
	top: 0;
	width: 100%;
	left: 0;
	background: rgba(0,0,0,.4);
	height: 100%;
	z-index: 99;
	display: none;
}
.toast{
	position: fixed;
	bottom: 50px;
	left: 50%;
	width: 140px;
	min-height: 20px;
	background: rgba(0,0,0,.6);
	margin-left: -70px;
	border-radius: 4px;
	color: #fff;
	padding: 3px 5px;
	font-size: 14px;
	text-align: center;
	line-height: 20px;
	display: none;
	z-index: 101;
}
.mui-bar-nav{
	box-shadow: none;
}
.mui-bar{
	background: #fff;
}
.mui-scroll-wrapper{
	top: 44px;
}
.chart {
	height: 200px;
	margin-top: 20px;
	padding: 0px;
  font-size: 0;
}

.screen-btn{
	height:50px;
	line-height: 50px;
	background: #fff;
	color:#4A4A4A;
	margin-bottom: 12px;
}
.screen-btn .division{
	position: relative;
}
.screen-btn .division:after{
	display: inline-block;
	content: "";
	width: 2px;
	height: 26px;
	position: absolute;
	top: 12px;
	right: 0;
	background: #EFEFEF;
}

#part1 {
	background: #fff;
	padding:16px 18px 20px 15px;
	margin-bottom: 12px;
  font-size: 0;
  text-align: left;
}
#part1 .sceenBox h2{
	font-size: 18px;
	color: #242424;
	text-align: center;
	margin-bottom:20px;
	position: relative;
}
#part1 .sceenBox h2::after{
	display: inline-block;
	content: "";
	width: 64px;
	height: 4px;
	background:#2574F6;
	position: absolute;
	left: 50%;
	margin-left: -32px;
	top: 25px;
	border-radius: 15px;
}
#part1 .sceenBox span{
	color: #979797;
	font-size: 14px;
}
#part1 .sceenBox ul{
	list-style: none;
	margin: 0;
	padding: 0;
}
#part1 .sceenBox ul li{
	width: 34px;
	height: 34px;
	background:#2574F6;
	color: #fff;
	font-size: 11px;
	line-height: 35px;
	text-align: center;
	border-radius: 50%;
	margin: 8px 4px;
	float: left;
}
#part1 .sceenBox ul li.userLiActive{
	background: #f39800;
}
.small-title{
  margin: 5px 0;
  text-align: left;
	font-size: 18px;
  font-weight: bold;
	color:#2574F6;
}

#part1 .mui-row{
	margin-top: 26px;
  display: flex;
}
.part1-col{
	flex: 1;
  text-align: center;
}
.part1-col div{
  text-align: center;
	font-size: 18px;
	color: #181818;
	margin-bottom: 9px;
}
.part1-col div i{
	font-size: 14px;
	font-style: normal;
}
.part1-col span{
	font-size: 14px;
	color: #4C4C4C;
}

.part1-sum  {
  flex: 1;
}
.part1-sum div{
  text-align: center;
	font-size: 12px;
	color:#4C4C4C;
}
.part1-sum div span{
	color:#F14F4C;
}


#part2{
	background: #fff;
	padding:16px 18px 20px 15px;
	margin-bottom: 12px;
  font-size: 0;
}
#part2 .mui-row{
	margin-top: 28px;
  display: flex;
}

#part3{
	background: #fff;
	padding:16px 18px 20px 15px;
  font-size: 0;
  .pull {
    display: flex;
    .pull-left {
      flex: 1;
      align-self: center;
    }
    .pull-right {
      flex: 0 0 100px;
      align-self: center;
	    margin-top:10px;
    }
  }
}
.part3-num{
	margin-top:10px;
  text-align: left;
}
.part3-num div:first-child{
	margin-bottom: 31px;
}
.part3-num div {
	font-size: 18px;
	color: #181818;
}
.part3-num div span{
	display: inline-block;
	width: 80px;
	color: #4C4C4C;
	font-size: 14px;
}
#part3 .mui-pull-right{
	padding-right: 30px;
}

/* 时间段底部弹出 */
#timeEject{
	display: none;
	width: 100%;
	position: fixed;
	bottom: 0;
	background: #fff;
	z-index: 100;
	padding-top: 14px;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
#timeEject h3{
	padding-left: 15px;
	font-size: 16px;
	color: #181818;
	margin-bottom: 18px;
}
#timeEject .btn-ul{
	margin: 0;
	padding: 0 14px;
	list-style: none;
	margin-bottom: 100px;
}
#timeEject .btn-ul li{
	float: left;
	width: 110px;
	height: 40px;
	text-align: center;
	line-height: 40px;
	background: #fff;
	border: 1px solid #EFEFEF;
	margin-right: 8px;
	margin-bottom: 8px;
	font-size: 14px;
	color: #4A4A4A;
	border-radius: 5px;
}
@media only screen and (max-width: 320px) {
    #timeEject .btn-ul li{
    	width: 90px;
    }
}
#timeEject .btn-ul li.time-active{
	background: #EDF2FE;
	border-color: #2574F6;
	color:#2574F6;
}
#timeEject .btn-ul li:nth-child(3n){
	margin-right: 0;
}
#timeEject .mui-table-view{
	margin-bottom: 122px;
}
#timeEject .mui-table-view:before,
#timeEject .mui-table-view:after{
	height: 0;
}
#timeEject .mui-table-view .mui-table-view-cell{
	font-size: 16px;
	color: #4A4A4A;
}
#timeEject .mui-table-view .mui-table-view-cell span{
	color: #181818;
	font-size: 14px;
	margin-right: 20px;
	display: inline-block;
    width: 60%;
    height: 20px;
    text-align: right;
}
.time-btn{
	box-shadow: 0 0 3px #EAEAEA;
}
.time-btn div{
	width: 50%;
	height: 50px;
	line-height: 52px;
	text-align: center;
	color: #4A4A4A;
	background: #fff;
}
.time-btn div:last-child{
	background: #2574F6;
	color: #fff;
}
[v-cloak] {
  display: none;
}
</style>